import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "courier-log-attendance",
  style: {"min-height":"85vh"}
}
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, " Absensi & Pencapaian Kurir ", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-xs color-blue-grey font-medium mt-2"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Filter Tanggal", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down" }, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "m-auto" }, [
    /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center font-bold" }, [
      /*#__PURE__*/_createTextVNode("Gunakan Filter tanggal untuk "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("Mengeluarkan data")
    ])
  ])
], -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "p-col-12 block" }
const _hoisted_11 = { class: "btn-action w-full flex justify-end mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListBlankCourier = _resolveComponent("ListBlankCourier")
  const _component_TableCourierLogAttendance = _resolveComponent("TableCourierLogAttendance")
  const _component_Card = _resolveComponent("Card")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Card, {
      class: "",
      style: {"min-height":"85vh !important"}
    }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", null, [
            _hoisted_3,
            ($setup.isShowTable)
              ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(`Filter : ${$setup.moment($setup.tempDateFilter[0]).format('DD MMM YYYY')} - ${$setup.moment($setup.tempDateFilter[1]).format('DD MMM YYYY')}`), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode("div", {
              class: ["btn-custom-outline flex cursor-pointer gap-2 px-2 py-1 items-center", $setup.isShowTable ? 'primary-color' : 'grey-color'],
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showDropDown($event)))
            }, [
              _hoisted_5,
              _hoisted_6
            ], 2)
          ])
        ])
      ]),
      content: _withCtx(() => [
        (!$setup.isShowTable)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_ListBlankCourier),
              _hoisted_8
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_9, [
              _createVNode(_component_TableCourierLogAttendance, {
                filterDate: $setup.tempDateFilter,
                ref: "refTableCourierLogAttendance"
              }, null, 8, ["filterDate"])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "dateOp",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode("span", _hoisted_10, [
          _createVNode(_component_Calendar, {
            modelValue: $setup.dateFilter,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ($setup.dateFilter = $event)),
            inline: true,
            showWeek: true,
            selectionMode: "range"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_11, [
            ($setup.dateFilter)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Filter",
                  class: "font-semibold p-button-sm btn-primary px-10 mr-2",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.saveFilterDate()))
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}